const VIEW_KEY = "hospital-switcher-view-v1";
const ASSISTANT_KEY = "hospital-assistant-cache";

export type SwitcherViewCache = {
  expandedMasterIds: string[];
  orderIds: string[];
  selectedId?: string | null;
};

export function readSwitcherView(): SwitcherViewCache | null {
  try {
    const raw = sessionStorage.getItem(VIEW_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      expandedMasterIds: Array.isArray(parsed?.expandedMasterIds)
        ? parsed.expandedMasterIds
        : [],
      orderIds: Array.isArray(parsed?.orderIds) ? parsed.orderIds : [],
      selectedId: parsed?.selectedId || null,
    };
  } catch {
    return null;
  }
}

export function writeSwitcherView(next: Partial<SwitcherViewCache>) {
  try {
    const current = readSwitcherView() || {
      expandedMasterIds: [],
      orderIds: [],
      selectedId: null,
    };
    sessionStorage.setItem(
      VIEW_KEY,
      JSON.stringify({
        expandedMasterIds: next.expandedMasterIds ?? current.expandedMasterIds,
        orderIds: next.orderIds ?? current.orderIds,
        selectedId: next.selectedId === undefined ? current.selectedId : next.selectedId,
      }),
    );
  } catch {
    // ignore quota / private mode
  }
}

export function readAssistantSessionCache(): any[] | null {
  try {
    const raw = sessionStorage.getItem(ASSISTANT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeAssistantSessionCache(data: any[]) {
  try {
    sessionStorage.setItem(ASSISTANT_KEY, JSON.stringify(data));
  } catch {
    // ignore
  }
}
